import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';

const LISTADO_GASTO = 'LISTADO_GASTO';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const LECTURA = 'LECTURA';
const DETALLE_CUENTAS = 'DETALLE_CUENTAS';
const DETALLE = 'DETALLE';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    dispatch(setLoader(true));
    api.get('/distribuidor/tipo_gasto', params).then((response)=>{
        dispatch({ type: LISTADO_GASTO, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar tipos de gasto',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroGasto = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormTipoGastoVM.values;
    let id_empresa = id_emp[5];

    if (data === undefined){
        Swal.fire({
            title: 'Tipo de gasto',
            text: 'Debe de ingresar descripción',
            type: 'error',
        })
    }else {
        if (data.descripcion === undefined || data.descripcion === ''){
            Swal.fire({
                title: 'Tipo de gasto',
                text: 'Debe de ingresar descripción',
                type: 'error',
            })
        }else {
            if (data.cuenta === undefined || data.cuenta === ''){
                Swal.fire({
                    title: 'Producto',
                    text: 'Debe de ingresar cuenta contable',
                    type: 'error',
                })
            }else {
                const formData = {
                    descripcion: data.descripcion,
                    detalle_cuentas: data.detalleD,
                    empresa: id_empresa
                }
                dispatch(setLoader(true));
                api.post('/distribuidor/tipo_gasto/', formData).then(() => {
                    NotificationManager.success(
                        'Tipo gasto creado',
                        'Exito',
                        3000
                    );
                    let ruta = `/visitador_medico/${id_emp[5]}/tipo_gasto`
                    dispatch(push(ruta));
                }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        2000
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });                
            }
        }
    }
}

export const modificarGasto = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormTipoGastoVM.values;
    const id = datos.id;
    if (datos.descripcion === undefined || datos.descripcion === ''){
        Swal.fire({
            title: 'Tipo de gasto',
            text: 'Debe de ingresar descripción',
            type: 'error',
        })
    }else {
        let cuentaContable = ''
        let cuenta = datos.cuenta_mod;
        if (cuenta === undefined){
            cuentaContable = datos.cuenta_contable;
        }else{
            cuentaContable = datos.cuenta_mod.value;
        }
        const formData = {
            id: id,
            descripcion: datos.descripcion,
            cuenta: cuentaContable,
        }
        dispatch(setLoader(true));
        api.put(`/distribuidor/tipo_gasto/${id}/`, formData).then(() => {
            NotificationManager.success(
                'Tipo de gasto modificado correctamente',
                'Exito',
                3000
            );
            let ruta = `/visitador_medico/${id_emp[5]}/tipo_gasto`
            dispatch(push(ruta));
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                2000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

const leerDetalleTipoGasto = id => (dispatch) => {
    api.get(`/distribuidor/tipo_gasto_detalle/${id}`).then((response) => {
        dispatch({ type: DETALLE_CUENTAS, detalleTipoGasto: response });
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            0
        );
    })
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/distribuidor/tipo_gasto/${id}`).then((response) => {
        dispatch(initializeForm('FormTipoGastoVM', response ));
        dispatch(leerDetalleTipoGasto(response.id));
        dispatch({ type: LECTURA, lectura: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar tipo de gasto',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


export const listarCuentasContables = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/distribuidor/cuenta_contable_distribuidor/buscar_cuenta_contable',params).then(data=>{
        const list_cuentas = [];
        if(data){
            data.forEach(item=>{
                list_cuentas.push({
                    value: item.id,
                    label: item.cuenta + ' -- ' + item.nombre
                })
            })
        }
        return list_cuentas;
    }).catch(()=>{
        return [];
    })
}

const actualizar = () => (dispatch, getStore) => {
    const data = getStore().form.FormTipoGastoVM.values;
    dispatch(initializeForm('FormTipoGastoVM', {
        ...data,
        cuenta: null
    }));
    dispatch({ type: DETALLE, detalleTipo: data.detalleD })
};


export const agregarLinea = () => (dispatch, getStore) => {
    const data = getStore().form.FormTipoGastoVM.values;
    if (data.cuenta === undefined || data.cuenta === '') {
        Swal.fire({
            title: 'Tipo de gasto',
            text: 'Debe de seleccionar cuenta contable',
            type: 'error',
        })
    } else {
        const detalleActual = data.detalleD || [];
        let dato = '';
        dato = detalleActual.find(item => item.cuenta === data.cuenta.value.trim());
        if (dato) {
            NotificationManager.error(
                'Cuenta contable ya fue ingresado',
                'Error',
                3000
            );
        }else {
            const nuevoDetalle = [
                ...detalleActual,
                {
                    id: Date.now(),
                    cuenta: data.cuenta.value,
                    cuenta_nombre: data.cuenta.label,
                }
            ];
            data.detalleD = nuevoDetalle;
            NotificationManager.success(
                'Cuenta contable ingresada correctamente',
                'Exito',
                3000
            );

            dispatch(actualizar());
        }
    }
}

const eliminarLinea = (id) => (dispatch, getStore) => {
    const data = getStore().form.FormTipoGastoVM.values;
    const nuevoDetalle = data.detalleD.filter(element => element.id !== id);
    dispatch({ type: DETALLE, detalleTipo: nuevoDetalle })
    dispatch(initializeForm('FormTipoGastoVM', {
        ...data,
        detalleD: nuevoDetalle,
        cuenta: null, // Limpiar el campo después de agregar
    }));
};

export const agregarLineaCuenta = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormTipoGastoVM.values;
    if (data.cuenta === undefined || data.cuenta === '') {
        Swal.fire({
            title: 'Tipo de gasto',
            text: 'Debe de seleccionar cuenta contable',
            type: 'error',
        })
    } else {
        const formData = {
            id: id_emp[7],
            cuenta: data.cuenta.value,
        }
        dispatch(setLoader(true));
        api.post('/distribuidor/tipo_gasto_detalle/', formData).then((response) => {
            NotificationManager.success(
                'Cuenta contable ingresada correctamente',
                'Exito',
                3000
            );
            dispatch(leerDetalleTipoGasto(response.id));
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                2000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

const eliminarLineaCuenta = id => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    dispatch(setLoader(true));
    api.eliminar(`/distribuidor/tipo_gasto_detalle/${id}`).then(() => {
        NotificationManager.success(
            'Cuenta contable borrada correctamente',
            'Exito',
            3000
        );
        dispatch(leerDetalleTipoGasto(id_emp[7]));
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar el producto',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const limpiarDatos = () => (dispatch) => {
    dispatch({ type: DETALLE, detalleTipo: [] })
};


export const actions = {
    listar,
    registroGasto,
    modificarGasto,
    leer,
    getModulo,
    listarCuentasContables,
    agregarLinea,
    agregarLineaCuenta,
    eliminarLinea,
    eliminarLineaCuenta,
    limpiarDatos
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [LISTADO_GASTO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [LECTURA]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [DETALLE_CUENTAS]: (state, { detalleTipoGasto }) => {
        return {
            ...state,
            detalleTipoGasto,
        };
    },
    [DETALLE]: (state, { detalleTipo }) => {
        return {
            ...state,
            detalleTipo,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: [],
    lectura: [],
    detalleTipoGasto: [],
    detalleTipo: []
};

export default handleActions(reducers, initialState)
 